import React from "react";
import { FaTimes } from "react-icons/fa";

const OrderFilters = ({
  pageSize,
  onPageSizeChange,
  searchField,
  onSearchFieldChange,
  searchValue,
  onSearchChange,
  onClearSearch,
  sortField,
  onSort,
  statusFilter,
  onStatusFilterChange,
  orders,
  statusOptions,
  showCurrentDateDiff,
  onToggleDateDiff,
}) => {
  const normalizeStatusValue = (value = "") =>
    value
      .toString()
      .trim()
      .toLowerCase()
      .replace(/[\s_-]+/g, "");

  const formatStatusLabel = (value = "") => {
    const normalized = normalizeStatusValue(value);
    if (normalized === "readytodispatch") return "Ready to Dispatch";
    if (normalized === "partialdispatch") return "Partial Dispatch";
    if (normalized === "new") return "New";
    if (normalized === "processing") return "Processing";
    if (normalized === "dispatch") return "Dispatch";
    if (normalized === "cancelled") return "Cancelled";
    return value;
  };

  const restrictedStatuses = new Set([
    "partialdispatch",
    "dispatch",
    "cancelled",
  ]);

  const fallbackFilterOptions = [
    { value: "processing", label: "Processing" },
    { value: "new", label: "New" },
    { value: "readytodispatch", label: "Ready to Dispatch" },
  ];

  const baseFilterOptions =
    Array.isArray(statusOptions) && statusOptions.length > 0
      ? statusOptions
      : fallbackFilterOptions;

  const visibleFilterOptions = baseFilterOptions
    .map((option) => ({
      value: normalizeStatusValue(option.value),
      label: formatStatusLabel(option.label),
    }))
    .filter((option) => option.value && !restrictedStatuses.has(option.value))
    .filter(
      (option, index, allOptions) =>
        index ===
        allOptions.findIndex((otherOption) => otherOption.value === option.value),
    );

  const orderedFilterOptions = [
    ...visibleFilterOptions.filter((option) => option.value === "processing"),
    ...visibleFilterOptions.filter((option) => option.value === "new"),
    ...visibleFilterOptions.filter((option) => option.value !== "new" && option.value !== "processing"),
  ];

  const getButtonClass = (value) => {
    if (value === "processing") {
      return statusFilter === value ? "btn-warning" : "btn-outline-warning";
    }
    if (value === "new") {
      return statusFilter === value ? "btn-primary" : "btn-outline-primary";
    }
    if (value === "readytodispatch") {
      return statusFilter === value ? "btn-success" : "btn-outline-success";
    }
    return statusFilter === value ? "btn-dark" : "btn-outline-dark";
  };

  const getStatusCount = (status) => {
    const normalizedStatus = normalizeStatusValue(status);
    return orders.filter(
      (o) => normalizeStatusValue(o.status || "") === normalizedStatus,
    ).length;
  };

  return (
    <>
      <div
        className="d-flex justify-content-between mb-3 sticky-header"
        style={{ position: "sticky", top: 0, left: 0, zIndex: 1, padding: "10px 0" }}
      >
        <div className="w-20 d-flex align-items-center gap-2">
          <select
            className="form-select w-auto me-2 table-page-size-select"
            value={pageSize}
            onChange={(e) => onPageSizeChange(Number(e.target.value))}
          >
            {[5, 10, 20, 50, 100].map(size => (
              <option key={size} value={size}>{size}</option>
            ))}
          </select>
          <span>Entries per page</span>
        </div>

        <div className="d-flex gap-2 align-items-center">
          <select
            className="form-select w-auto table-filter-size-select"
            value={searchField}
            onChange={(e) => onSearchFieldChange(e.target.value)}
          >
            <option value="Order_ID" >Order ID</option>
            <option value="Party_Name">Party Name</option>
            <option value="Design_Colour">Design Colour</option>
            <option value="Design_Name">Design Name</option>
            <option value="Quantity">Quantity</option>
            <option value="Order_Date">Order Date</option>
            <option value="OrderType">Order Type</option>
            <option value="Status">Status</option>
          </select>
          <div className="position-relative">
            <input
              type="text"
              placeholder="Search"
              className="form-control small-search-input pe-4"
              value={searchValue}
              onChange={onSearchChange}
            />
            {searchValue && (
              <FaTimes
                onClick={onClearSearch}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  color: "#6c757d",
                }}
              />
            )}
          </div>
        </div>
      </div>

      <div className="mb-3">
        <div className="d-flex gap-2">
          {orderedFilterOptions.map((option) => (
            <button
              key={option.value}
              className={`btn btn-sm ${getButtonClass(option.value)}`}
              onClick={() => onStatusFilterChange(option.value)}
            >
              {option.label} ({getStatusCount(option.value)})
            </button>
          ))}
          <button
            className={`btn btn-sm ${statusFilter === "all" ? "btn-secondary" : "btn-outline-secondary"}`}
            onClick={() => onStatusFilterChange("all")}
          >
            All ({orders.length})
          </button>
        </div>
      </div>
    </>
  );
};

export default React.memo(OrderFilters);